import React from "react";
import AllPosters from "../AllSessions";
import "./index.css";

const Presentation = ({ config }) => {
  return (
    <div>
      <AllPosters
        config={config}
        header={
          <div className="sessions-header">
            <img
              className="header-logo"
              src={"/logo/paso-banner.png"}
              alt="Logo"
            />
          </div>
        }
      />
    </div>
  );
};

export default Presentation;
